(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name applicationParameters.factory:ApplicationParametersFactory
	 * 
	 * @description
	 * 
	 */
	angular.module('applicationParameters').factory(
			'ApplicationParametersFactory', ApplicationParametersFactory);

	function ApplicationParametersFactory() {

		// ----declare DTOs------
		function AppParamSearchRequest() {
			this.appParameterDesc = null;
		}
		
		function AppParamSaveRequest(){
			this.applicationParams =[],
			this.updateNow = false
		}
		
		function AppParamSaveDTO(){
			this.paramValue = null;
			this.paramKey = null;
			this.version = null;
		}

		// ----Define Function --------
		//getter and setter of app param search request
		function GetAppParamSearchRequest() {
			return new AppParamSearchRequest();
		}

		function GetFormattedAppParamSearchRequest(searchCrieteria) {
			var searchReq = new AppParamSearchRequest();
			if (!!searchCrieteria && !!searchCrieteria.appParameterDesc
					&& searchCrieteria.appParameterDesc.trim() != '') {
				searchReq.appParameterDesc = searchCrieteria.appParameterDesc;
			}
			return searchReq;
		}
		
		function AdaptAppParamList(appParamList){
			if(!!appParamList && appParamList.length>0){
				appParamList = appParamList.filter(function(appParam){
					return appParam.showOnUI === 'Y';
				});
				for(var i=0;i<appParamList.length;i++){
					//convert string numbers to number format
					if(appParamList[i].type=='N'){
						appParamList[i].paramValue = Number(appParamList[i].paramValue);
					}
				}
			}
			return appParamList;
		}
		
		function GetAppParamSaveRequest(){
			return new AppParamSaveRequest();
		}
		
		function GetFormattedAppParamSaveDTO(appParam){
			var appParamSaveDTO = new AppParamSaveDTO();
			appParamSaveDTO.paramValue = appParam.type == 'N' ? appParam.paramValue+''
					: appParam.paramValue;
			appParamSaveDTO.paramKey = appParam.paramKey;
			appParamSaveDTO.version = appParam.version;
			return appParamSaveDTO;
		}
		
		
		// map services to return
		return {
			getAppParamSearchRequest : GetAppParamSearchRequest,
			getFormattedAppParamSearchRequest : GetFormattedAppParamSearchRequest,
			adaptAppParamList : AdaptAppParamList,
			getAppParamSaveRequest : GetAppParamSaveRequest,
			getFormattedAppParamSaveDTO:GetFormattedAppParamSaveDTO
		}

	}
})();